const ForkKnifeIcon: React.FC = () => (
  <span role="img" aria-label="food" className="anticon">
    <svg
      viewBox="64 64 896 896"
      width="1em"
      height="1em"
      fill="none"
      stroke="currentColor"
      strokeWidth={60}
      strokeLinecap="round"
      strokeLinejoin="round"
      xmlns="http://www.w3.org/2000/svg"
    >
      {/* Plate */}
      <circle cx="512" cy="512" r="380" />
      {/* Fork: 3 tines + stem */}
      <line x1="400" y1="200" x2="400" y2="360" />
      <line x1="440" y1="200" x2="440" y2="360" />
      <line x1="480" y1="200" x2="480" y2="360" />
      <path d="M400 360 Q400 420 440 430 L440 780" />
      <path d="M480 360 Q480 420 440 430" />
      {/* Knife: straight back, tapered blade */}
      <path d="M580 200 L580 400 Q580 430 620 440 L620 780" />
      <path d="M580 200 Q610 200 620 260 L620 440" />
    </svg>
  </span>
);

export default ForkKnifeIcon;
